<template>
<div>
    <trademark-form ref="trademarkForm"></trademark-form>
    <b-row class="align-items-center mb-1">
        <b-col></b-col>
        <b-col class="d-flex justify-content-end col-lg-4 mt-2">
            <b-button style="float:right;" class="d-inline-block mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getTrademarkAgendaReportList()" @click="getTrademarkAgendaReportList()">{{ $t('trademarkAgendaReport.list') }}</b-button>
            <b-button style="float:right;" class="d-inline-block" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="trademarkAgendaReportTable" ref="trademarkAgendaReportTable" :columns="columns" :rows="rows" :search-options="{
                enabled: true,
                externalQuery: searchTerm,
              }" styleClass="vgt-table condensed tableSize" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'recordNo'" class="text-nowrap">
                {{ $t('trademarkAgendaReport.record_no') }}
            </span>
            <span v-else-if="props.column.field === 'trademarkName'" class="text-nowrap">
                {{ $t('trademarkAgendaReport.name') }}
            </span>
            <span v-else-if="props.column.field === 'applicationNo'" class="text-nowrap">
                {{ $t('trademarkAgendaReport.application_no') }}
            </span>
            <span v-else-if="props.column.field === 'trademarkHistory.trademarkStatus'" class="text-nowrap">
                {{ $t('trademarkAgendaReport.status') }}
            </span>
            <span v-else-if="props.column.field === 'trademarkHistory.employee'" class="text-nowrap">
                {{ $t('trademarkAgendaReport.employee') }}
            </span>
            <span v-else-if="props.column.field === 'passedTime'" class="text-nowrap">
                {{ $t('trademarkAgendaReport.passed_time') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.trademarkId)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <span>
                        <b-button v-b-tooltip.html :title="$t('trademarkAgendaReport.send_reminder_mail')" variant="success" class="btn-icon mb-1 ml-1" size="sm" @click="showMailForm(props.row)">
                            <feather-icon icon="MailIcon" />
                        </b-button>
                    </span>
                </span>
            </span>

        </template>
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50','100']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <!-- ,'100', '1000' -->
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getTrademarkAgendaReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        trademarkId: Number,
        getTrademarkList: {
            type: Function
        },
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('trademarkAgendaReport.record_no'),
                    field: 'recordNo',
                },
                {
                    label: this.$t('trademarkAgendaReport.name'),
                    field: 'trademarkName',
                },
                {
                    label: this.$t('trademarkAgendaReport.application_no'),
                    field: 'applicationNo',
                },
                {
                    label: this.$t('trademarkAgendaReport.status'),
                    field: 'trademarkHistory.trademarkStatus',
                },
                {
                    label: this.$t('trademarkAgendaReport.employee'),
                    field: 'trademarkHistory.employee',
                },
                {
                    label: this.$t('trademarkAgendaReport.passed_time'),
                    field: 'passedTime',
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
            pageLength: 10,
            pageNo: 1,
            total: 0,
            reportTypeId: 0,
        }
    },
    mounted() {
        this.reportTypeId = this.$route.query.id;
        this.getTrademarkAgendaReportList()
    },
    methods: {
        async getInfo(trademarkId) {
            this.$refs.trademarkForm.showInfo(trademarkId)
        },
        getTrademarkAgendaReportList() {
            this.rows = []
            const data = {
                reportTypeId: this.reportTypeId,
                pageLength: this.pageLength,
                pageNo: this.pageNo
            }
            const controller = {
                name: 'Trademark',
                actionName: 'GetTrademarkRecordsAreNotIRAgendaReport'
            }
            const payload = {
                controller: controller,
                data: data
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.trademarkRecordsAreNotIRAgendaReport
      
                    this.total = response.data.total
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    loader.hide()
                }
                loader.hide()
            })
        },
        exportExcel() {
            var controller = {
                name: 'Trademark',
                actionName: 'CanExport'
            }
            var data = {
                columnList: this.columns,
                dataList: this.rows
            }
            var payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Trademark Renewal Report", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
